import React from 'react';

import { Box, MenuItem, MenuList, useTheme } from '@material-ui/core';

import { GridActions } from '@vyce/core/src/components';
import { usePermissions } from '@vyce/core/src/hooks/usePermissions';
import { TEAMS_PERMISSIONS } from '@vyce/core/src/types';

import { monochrome } from '../../../theme/styles';

export const CustomActionCell = ({
  userId,
  teamId,
  isManager = false,
  changeManager,
  deleteTeamMembers,
}: {
  userId: string;
  /** The row only knows the user, so the parent supplies the team it belongs to. */
  teamId?: string;
  isManager: boolean;
  changeManager: (userId: string, isManager: boolean) => void;
  deleteTeamMembers: (userId: string) => void;
}) => {
  const theme = useTheme();
  const { canOnResource } = usePermissions();
  const canEditTeam = canOnResource(TEAMS_PERMISSIONS.CAN_EDIT_TEAMS, 'team', teamId);
  const canRemoveMembers = canOnResource(TEAMS_PERMISSIONS.CAN_REMOVE_TEAM_MEMBERS, 'team', teamId);

  const textColor = theme.palette.type === 'dark' ? monochrome.medium : monochrome.mediumdark;

  const handleDeleteTeamMembers = () => deleteTeamMembers(userId);
  const handleChangeManager = () => changeManager(userId, isManager);

  // Nothing to offer — don't render a button that opens an empty menu.
  if (!canEditTeam && !canRemoveMembers) return null;

  return (
    <Box display="flex" width="100%">
      <GridActions
        renderEnrichedList={({ closeAnchorEl }) => (
          <MenuList>
            {canEditTeam && (
              <MenuItem
                cy-test-id="change-manager-button"
                onClick={() => {
                  handleChangeManager();
                  closeAnchorEl();
                }}>
                <Box color={textColor}>{isManager ? 'Remove manager role' : 'Make a manager'}</Box>
              </MenuItem>
            )}
            {canRemoveMembers && (
              <MenuItem
                cy-test-id="remove-user-from-team-button"
                onClick={() => {
                  handleDeleteTeamMembers();
                  closeAnchorEl();
                }}>
                <Box color={textColor}>Remove from this Team</Box>
              </MenuItem>
            )}
          </MenuList>
        )}></GridActions>
    </Box>
  );
};
